<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<script setup lang="ts">
import AppBreadcrumbs from "./AppBreadcrumbs.vue";
import AppFooter from "./AppFooter.vue";
import AppHeader from "./AppHeader.vue";
import AppSidebar from "./AppSidebar.vue";
</script>

<template>
  <div class="application-shell">
    <AppHeader />
    <div class="application-workspace">
      <AppSidebar />
      <div class="application-content">
        <AppBreadcrumbs />
        <main class="page-content">
          <slot />
        </main>
        <AppFooter />
      </div>
    </div>
  </div>
</template>
